export default () => {
  let $elements = $('.border-bottom-full-width');

  $elements.each(function() {
    let observer = new IntersectionObserver(function(entries) {
      let entry = entries[0];
      if (entry.isIntersecting) {
        $(entry.target).addClass('border-scroll--appear');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.5 });

    observer.observe(this);
  });
}



// WEBPACK FOOTER //
// ./scripts/layouts/scrolling-border.js